var map = {
	"./alto-mayo.jpg": 4596,
	"./alto-mayo/20160710_131742.jpg": 4929,
	"./alto-mayo/20160710_131754.jpg": 8048,
	"./alto-mayo/20160710_132406.jpg": 2639,
	"./alto-mayo/IMG_5207.jpg": 1635,
	"./alto-mayo/IMG_5209.jpg": 5045,
	"./alto-mayo/IMG_5210.jpg": 9487,
	"./alto-mayo/alto-mayo.jpg": 9094,
	"./alto-mayo/lnfjkfrekf.jpg": 516,
	"./carpishuyacu.jpg": 8386,
	"./carpishuyacu/IMG_5625.jpg": 7397,
	"./carpishuyacu/PISHURAYACU...jpg": 3824,
	"./carpishuyacu/cliente1.jpg": 7152,
	"./cascada-hushiaco.jpg": 332,
	"./cascada-hushiaco/AHUASHIYACU198.jpg": 4374,
	"./cascada-hushiaco/AHUASHIYACU449.jpg": 9237,
	"./cascada-hushiaco/cascada-hushiaco.jpg": 7482,
	"./cascada-hushiaco/catarata-ahuashiyacu-tour-1.jpg": 8085,
	"./laguna-azul.jpg": 790,
	"./laguna-azul/IMG-20140926-01136.jpg": 6019,
	"./laguna-azul/IMG_5427.jpg": 2073,
	"./laguna-azul/Laguna azul.jpg": 319,
	"./laguna-azul/sauce-laguna azul.jpg": 2433,
	"./lamas.jpg": 3473,
	"./lamas/20150627_110205.jpg": 5711,
	"./lamas/20150627_111505.jpg": 4291,
	"./lamas/20150627_111802.jpg": 3841,
	"./lamas/20150627_113041.jpg": 7604,
	"./lamas/20190822_155623.jpg": 2805,
	"./lamas/20190822_165851.jpg": 5515,
	"./lamas/20190822_170239.jpg": 2909,
	"./lamas/20190822_171245.jpg": 6875,
	"./lamas/20190822_171259.jpg": 7660,
	"./lamas/20190822_171818.jpg": 6003,
	"./lamas/20190822_172156.jpg": 3933,
	"./lamas/20190822_172754.jpg": 7989,
	"./lamas/20190925_175339.jpg": 7345,
	"./lamas/CASTILLO DE LAMAS.jpg": 4376,
	"./lamas/castillolamas01.jpg": 712,
	"./lamas/tour-lamas-1.jpg": 9379,
	"./mirador-tarapoto.jpg": 5452,
	"./mirador-tarapoto/IMG_1985.jpg": 9450,
	"./mirador-tarapoto/Taytamaki_2.jpg": 7291,
	"./mirador-tarapoto/mirador-tarapoto.jpg": 4258,
	"./principal.jpg": 9793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9769;